import { Text } from '@mantine/core';

import type { HoursDisplayViewProps } from './HoursDisplay.types';

export function formatHours(hours: number) {
  return hours % 1 === 0 ? `${hours}t` : `${hours.toFixed(1)}t`;
}

export function HoursDisplayView({ hours, fallback = '–', fw, size = 'sm' }: HoursDisplayViewProps) {
  if (hours == null) {
    return (
      <Text size={size} c="dimmed" span>
        {fallback}
      </Text>
    );
  }

  return (
    <Text size={size} fw={fw} span>
      {formatHours(hours)}
    </Text>
  );
}
